module.exports = __webpack_public_path__ + "img/design-modeling-clothing.6795970b.jpg";